export default __webpack_public_path__ + "static/button-primary-do-dark-8d5cc91f3a8849c8b8009598e8b0de22.png";